<template>
  <div v-if="showUserContent">
    <div
      v-if="user && userData"
      class="content"
    >
      <div class="md-layout text-center">
        <md-card class="md-layout-item md-size-30 md-medium-size-100 left-card">
          <avatar-with-level-info :user="userData" />
          <md-button
            v-if="isMyUser"
            class="md-danger"
            @click="navigateToEditPage"
          >
            <md-icon>edit</md-icon>
            <span class="edit-button-text">{{ $t('userProfile.editProfile') }}</span>
          </md-button>
          <router-link
            :to="(isMyUser)?'/pages/friends':''"
            class="my-friends-button"
          >
            <div class="md-layout-item user-info">
              <span>{{ $t('friends.friends') }}</span>
              <span class="stats">{{ userData && userData.friends ? userData.friends.connected.length : 0 }}</span>
            </div>
          </router-link>
          <div class="md-layout-item user-info">
            <span>{{ $t('challengePage.finishedChallenges') }}</span>
            <span class="stats">{{ completedChallenges }}</span>
          </div>

          <div
            class="md-layout-item"
            style="margin: 10px 0"
          >
            <div class="badges">
              <span><b>Badges</b> {{ myBadges.length }}</span>
              <a
                class="link"
                href="#/pages/badges"
              >{{ $t('general.more') }} ></a>
            </div>
            <div class="badge-info">
              <div
                v-for="badge in myBadges.slice(0, 5)"
                :key="badge.id"
                class=""
              >
                <div class="badge">
                  <div>
                    <img :src="badge.icon">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-card>

        <div
          class="md-layout-item md-size-65 md-medium-size-100"
          style="margin: 35px 0 0;"
        >
          <md-tabs
            class="user-profile-tabs"
            md-alignment="centered"
            :md-active-tab="activeTab"
            @md-changed="onTabChange($event)"
          >
            <md-tab
              id="tab-activities"
              md-label="ACTIVITIES"
            >
              <div class="scrollable">

    <div class="bar-chart-container md-layout" v-if="statisticsData.sum">
      <div class="md-layout-item md-size-33 card" v-if="statisticsData.sum.distanceInMeters" @click="selectedCard = 'distanceInMeters'">
        <activity-info :activity="statisticsData.sum.distanceInMeters" :display-column="true" :selected="selectedCard == 'distanceInMeters'"></activity-info>
      </div>
      <div class="md-layout-item md-size-33 card" v-if="statisticsData.sum.durationInSeconds" @click="selectedCard = 'durationInSeconds'">
        <activity-info :activity="statisticsData.sum.durationInSeconds" :display-column="true" :selected="selectedCard == 'durationInSeconds'" ></activity-info>
      </div>
      <div class="md-layout-item md-size-33" v-if="statisticsData.sum.caloriesBurned" @click="selectedCard = 'calories'">
        <activity-info :activity="statisticsData.sum.caloriesBurned" :display-column="true" :selected="selectedCard == 'calories'"></activity-info>
      </div>
    </div>
                <bar-chart
                  :statistics="statisticsData"
                  :key="chartKey"
                  @getStatistics="getStatistics($event)"
                />
                <div class="activities">
                  <div
                    v-for="activity in activities"
                    :key="activity.activityId"
                    class="md-layout-item md-size-45 md-xsmall-size-100"
                    style="padding: 0 3px !important;"
                  >
                    <activity-card
                      :activity="activity"
                      @like="like($event)"
                      @redirectToActivity="redirectToActivity($event)"
                    />
                  </div>
                </div>
              </div>
            </md-tab>
            <md-tab
              id="tab-challenges"
              md-label="CHALLENGES"
            >
              <md-card class="md-layout-item md-size-100 challenge-filter">
                <md-field class="md-layout-item md-size-50">
                  <label>Status</label>
                  <md-select
                    v-model="filterByStatus"
                    name="filter by status"
                  >
                    <md-option value="all">
                      All
                    </md-option>
                    <md-option value="joined">
                      Active
                    </md-option>
                    <md-option value="done">
                      Completed
                    </md-option>
                  </md-select>
                </md-field>
              </md-card>
              <div class="scrollable md-layout">
                <div
                  v-for="challenge in challenges"
                  :key="challenge._id"
                  class="md-layout-item md-xsmall-size-100 md-size-45"
                  @click="redirectToChallenge(challenge._id)"
                >
                  <challenge-card
                    card-header="true"
                    class="card"
                  >
                    <img
                      v-if="challenge.titleImage"
                      slot="imageHeader"
                      :src="challenge.titleImage"
                    >
                    <div
                      slot="title"
                      class="h4"
                      v-html="challenge.title"
                    />
                    <span slot="date">
                      {{ formatFromToDate(challenge.start, challenge.end) }}
                    </span>
                    <p
                      slot="description"
                      class="card-description"
                      v-html="challenge.feedDescription"
                    />
                  </challenge-card>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </div>
      </div>
    </div>
    <div v-else>
      LOADING
    </div>
  </div>
  <div
    v-else
    class="page-not-allowed"
  >
    <page-not-allowed />
  </div>
</template>

<script>
import datetime from "@/utils/datetime";
import { ChallengeCard } from "@/components";
import {mapState} from "vuex";

import activity from "@/utils/activity";

import AvatarWithLevelInfo from "sports4me-web_components/atomic-design/atoms/avatar-with-level-info";
import PageNotAllowed from "sports4me-web_components/atomic-design/atoms/page-not-allowed";
import ActivityCard from "sports4me-web_components/atomic-design/molecules/activity-card";
import BarChart from "sports4me-web_components/atomic-design/molecules/bar-chart";
import ActivityInfo from 'sports4me-web_components/atomic-design/atoms/activity-info';


export default {
  components: {
    AvatarWithLevelInfo,
    ActivityCard,
    ChallengeCard,
    PageNotAllowed,
    BarChart,
    ActivityInfo
  },
  data() {
    return {
      chartKey: 1,
      challenges: [],
      myBadges: [],
      activities: [],
      statisticsData: {},
      selectedCard: 'distanceInMeters',
      defaultImage: this.$store.state.defaultAvatar,
      completedChallenges: 0,
      filterByStatus: 'all',
      userData: undefined,
      isMyUser: false,
      activeTab: 'tab-activities',
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    showUserContent() {
      return this.user && (this.user.friends.connected.includes(this.routerId) || this.user._id == this.routerId)
    }
  },
  watch: {
    user() {
      if(this.user && this.user._id && this.showUserContent)
        this.loadData();
    },
    $route (to, from){
      this.routerId = to.params.id;
      this.challenges = [];
      this.activities = [];
      this.background = [];
      this.activeTab = 'tab-activities';
      if (this.showUserContent) {
        this.loadData();
      }
    },
    filterByStatus(val) {
      switch (val) {
        case 'joined':
          this.$store
              .dispatch("queryAPI", {
                url: this.isMyUser
                    ? "/rest/challenge?view=joined"
                    : `/rest/challenge?view=joined&friendId=${this.routerId}`
              }).then(data => { this.challenges = data });
          break;
        case 'done':
          this.$store
              .dispatch("queryAPI", {
                url: this.isMyUser
                    ? "/rest/challenge?view=done"
                    : `/rest/challenge?view=done&friendId=${this.routerId}`
              }).then(data => { this.challenges = data });
          break;
        default:
          this.challenges = [];
          this.$store
              .dispatch("queryAPI", {
                url:  this.isMyUser
                    ? "/rest/challenge?view=done"
                    : `/rest/challenge?view=done&friendId=${this.routerId}`
              }).then(data => { this.challenges = [...this.challenges, ...data] });

          this.$store
              .dispatch("queryAPI", {
                url: this.isMyUser
                    ? "/rest/challenge?view=joined"
                    : `/rest/challenge?view=joined&friendId=${this.routerId}`
              }).then(data => { this.challenges = [...this.challenges, ...data] });
          break;
      }
    },
    selectedCard(val) {
      if(this.statisticsData.allData.length > 0) {
        this.statisticsData.allData.forEach(item => {
          if(item.data) {
            this.statisticsData.data.push({date: this.formatDate(item.date, false, 'YYYY-MM-DD'), data: (item.data[val])});
          }
        })
        this.chartKey=(new Date().getTime())
      }
    }
  },
  created() {
    this.routerId = this.$route.params.id;
    if(this.user && this.user._id && this.showUserContent)
      this.loadData();

  },
  methods: {
    ...datetime,
    ...activity,
    onTabChange(tab) {
      this.activeTab = tab
      if (tab == 'tab-challenges') {
        if (this.user && (this.user._id == this.routerId || this.routerId == 'me')) {
          this.$store
              .dispatch("queryAPI", {url: "/rest/challenge?view=joined"})
              .then(data => {
                this.challenges = [...this.challenges, ...data]
              });
        } else {
          this.$store
              .dispatch("queryAPI", {url: `/rest/challenge?view=joined&friendId=${this.routerId}`})
              .then(data => { this.challenges = [...this.challenges, ...data]});
        }
      }
    },
    loadData() {
      this.isMyUser = (this.user && this.user._id == this.routerId)
      if (this.user && (this.user._id == this.routerId || this.routerId == 'me')) {
        this.getMyUserData();
      }
      else if(this.user && this.user._id != this.routerId) {
        this.getFriendData(this.routerId)
        this.$store
            .dispatch("queryAPI", { url: "/rest/user/friend/" + this.routerId })
            .then(res => {
              this.userData = res
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                icon: "add_alert",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "danger"
              });
            });
      } else {
        this.getMyUserData();
      }
    },
    getStatistics(data) {
      let request = {url: "/rest/statistic/user/" + this.user._id, options: {}};
      if (data) {
        request.options.start = this.getOnlyDayIsoString(data.start);
        request.options.end = this.getOnlyDayIsoString(data.end);
        }
      this.$store
          .dispatch("queryAPI", request)
          .then(res => {
            this.statisticsData = res
            this.getSumOfStatistics(res.data || []);
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
      // console.log(data)
    },
    getSumOfStatistics(data) {
      this.statisticsData = {
        allData: data,
        data: [],
        sum: {
          activities: {
            value: 0
          },
          distanceInMeters: {
            title: 'COVERED',
            parameter: 'km',
            image: '/img/activity-data-icons/distance.svg',
            value: 0
          },
          durationInSeconds: {
            title: 'SPENT',
            parameter: 'h',
            image: '/img/activity-data-icons/duration.svg',
            value: 0
          },
          caloriesBurned: {
            title: 'BURNED',
            parameter: 'kcal',
            image: '/img/activity-data-icons/fire.svg',
            value: 0
          }
        }
      }
      if(data.length > 0) {
        data.forEach(item => {
          if(item.data) {
            this.statisticsData.sum.activities.value += item.data.activities || 0;
            this.statisticsData.sum.distanceInMeters.value += item.data.distanceInMeters || 0;
            this.statisticsData.sum.durationInSeconds.value += item.data.durationInSeconds || 0;
            this.statisticsData.sum.caloriesBurned.value += item.data.calories || 0;
            this.statisticsData.data.push({date: this.formatDate(item.date, false, 'YYYY-MM-DD'), data: (item.data[this.selectedCard])});
          }
        })
      }
    },
    getMyUserData() {
      this.userData = this.user;
      this.$store
          .dispatch("queryAPI", { url: "/rest/challenge?view=done"})
          .then(data => {
            this.challenges = [...this.challenges, ...data];
            this.completedChallenges = data.length
          });



      this.$store.dispatch("queryAPI", {url: "/rest/badge?view=my"})
          .then(res => {
            this.myBadges = res;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      this.$store
          .dispatch("postAPI", {url: "/rest/activity", data: {me: 1}})
          .then(data => (this.activities = data))
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      // this.getStatistics() // !!!!!!!!!!
      },
    getFriendData(friendId) {
      this.$store
          .dispatch("queryAPI", { url: `/rest/challenge?view=done&friendId=${friendId}`})
          .then(data => {
            this.challenges = [...this.challenges, ...data];
            this.completedChallenges = data.length
          });



      this.$store.dispatch("queryAPI", {url: `/rest/badge?view=friend&userId=${friendId}`})
        .then(res => {
          this.myBadges = res;
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
        });

        this.$store
          .dispatch("postAPI", {url: "/rest/activity", data: { me: 0, friends: [friendId] }})
          .then(data => (this.activities = data))
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
    },
    navigateToEditPage() {
      this.$router.push(`${this.user._id}/edit`)
    },
    like(item) {
      if (! (item.activityId && this.likeable(item))) return false;
      this.$store
          .dispatch("queryAPI", {
            url: "/rest/activity/" +
                ((this.liked(item)) ? 'unlike' : 'like') +
                '/' + item.activityId
          })
          .then(res => {
            if (res.success) {
              (this.liked(item)) ? item.liked = item.liked.filter(i => i!=this.user._id) : item.liked.push(this.user._id)
            }
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              type: "error"
            });
          });
    },
    likeable(item) {
      if (item.userId == this.user._id) return false;
      return true
    },
    liked(item) {
      if (item.liked.includes(this.user._id)) return true;
      return false
    },
    redirectToActivity(activityId) {
      this.$router.push('./../activity/' + activityId);
    },
    redirectToChallenge(challengeId) {
      this.$router.push('./../Challenges/' + challengeId);
    }
  },
};
</script>
<style lang="scss">
// NO STYLING here
// .text-center {
//   display: flex;
//   justify-content: space-between;
//   .left-card {
//     display: flex;
//     flex-direction: column;
//     height: fit-content;
//     margin-top: 0 !important;
//     .edit-button-text {
//       // font-style: to-upper-case($string: "XXX");
//       font-weight: 500;
//       font-size: 14px;
//       padding-left: 6px;
//     }
//     .user-info {
//       display: flex;
//       justify-content: space-between;
//       border-bottom: 1px solid rgba(0, 0, 0, 0.1);
//       font-size: 14px;
//       font-weight: 400;
//       color: rgba(140, 114, 114, 1);
//       padding-top: 10px;
//       padding-bottom: 10px;
//       .stats {
//         font-size: 16px;
//         font-weight: 500;
//         color: black;
//       }
//     }
//     .badges {
//       display: flex;
//       justify-content: space-between;
//       .link {
//         color: #005FB6;
//       }
//     }
//     .badge-info {
//       display: flex;
//     }
//   }
// }
.md-tabs-content table thead {
  display: contents;
}

.md-tabs-navigation {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.user-profile-tabs .md-tabs-content {
  background: #eeeeee !important;
  .md-tab {
    padding: 0 !important;
  }
}

.table-results-content {
  padding: 0 !important;
}
.table-results-content .result-table {
  padding: 0 16px;
}
.user-profile-tabs .md-content {
  //height: calc(100vh - 260px) !important;
  //overflow-y: auto;
  &.md-theme-default {
    height: 100%;
  }
}

.user-profile-tabs {
  .scrollable {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: calc(100vh - 170px);
    overflow-y: auto;
    .md-layout-item {
      padding: 0 !important;
    }
    .activities {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  .private-challenge-title {
    display: flex;
    margin-top: 12px;
    padding: 8px 0;
    .title {
      font-size: 34px;
      font-weight: 500;
      margin-left: 8px;
    }
  }

  .md-tab-nav-button {
    width: 30%;

    .md-button-content {
      color: rgba(0, 0, 0, 0.54);
      font-size: 14px;
      font-weight: 500;
    }
    &.md-active {
      border-bottom: 2px solid #DF263B;
      .md-button-content {
        color: #DF263B !important;
      }
    }
  }
}

.page-not-allowed {
  position: sticky;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: center;
}
div.activity-card div.md-card-content {
  padding-top: 0;
}
.challenge-filter {
  margin: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  box-shadow: none;
  border-top: 1px solid #E0D8D8;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

</style>
